<template>
  <div>
    <button class="btn btn-danger" data-toggle="modal" data-target="#exampleModal" id="btnModal" style="visibility:hidden;" ></button>
    <button class="btn btn-danger" @click="getScrapperLogs" >Ver logs</button>
    


    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Historial de Eventos</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table" id="content-table-scrapper">
              <thead>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">Proceso</th>
                  <th scope="col">Status</th>
                  <th scope="col">Evento</th>
                </tr>
              </thead>
              <tbody id="tbody">
              </tbody>
            </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>

<script>
import api from './../../../mixiens/api'
export default {
  name:'ReferenceLogsTable',
  mixins:[api],
  props:['project_id','reference_type'],
  data(){
    return{
      logs:[],
      translates:{
        contacted:"Mensaje Enviado",
        withoutanswer:"Sin Respuesta",
        done:'Mensaje Respondido',
        errors:'Ocurrió un error',
        resend:'Mensaje Reenviado'
      }
    }

  },
  methods:{
    async getScrapperLogs(){
      let tbody = document.getElementById('tbody')
      tbody.innerHTML = ''
      let logs = await this.getReferenceLogs(this.project_id,this.reference_type)
      if(this.reference_type == "PersonalReference"){
        const family_logs = await this.getReferenceLogs(this.project_id,'FamilyReference')
        logs = logs.concat(family_logs)
        console.log('Los logs del if',logs)
      }
      console.log('Los logs',logs)
      const optionsTime = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      };
      for(let i = 0; i<logs.length;i++){
        let scrapper = logs[i]
        console.log(scrapper)
        let tr = document.createElement('tr')
        tr.style = "font-size:14px; text-align:left;"
        let tdFecha = document.createElement('td')
        let tdHora = document.createElement('td')
        let tdId = document.createElement('td')
        let tdStatus = document.createElement('td')
        let tdEvent = document.createElement('td')
        tdFecha.innerText = new Date(scrapper.created_at).toISOString().substr(0,10) + ' ' + new Date(scrapper.created_at).toLocaleString('en-US', optionsTime)
        tdFecha.style = "font-size:14px; width:28%;"
        tr.appendChild(tdFecha)
        tdId.innerText = scrapper.project_id
        tr.appendChild(tdId)
        tdStatus.innerText = this.translates[scrapper.status]
        tr.appendChild(tdStatus)
        tdEvent.innerText = scrapper.event
        tr.appendChild(tdEvent)
        tbody.appendChild(tr)
      }
      document.getElementById('btnModal').click()
    }
  }
}
</script>

<style>

</style>